module.exports = __webpack_public_path__ + "img/water.0d2c1d69.jpg";